import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import { v4 as uuidv4 } from 'uuid';

import i18next from "i18next";
function ListadoCargosContenedor() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CARGOS_CONTENEDOR = process.env.REACT_APP_URL_CARGOS_CONTENEDOR;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_CONTENEDORES = process.env.REACT_APP_URL_CONTENEDORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_CONCEPTOS_GASTOS = process.env.REACT_APP_URL_CONCEPTOS_GASTOS;
  const [t, i18n] = useTranslation("global");
  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);
  let inicio2 = moment(inicio).format("YYYY-MM-DD");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(inicio2);
  const [selectedFechaFin, setSelectedFechaFin] = useState(hoy);
      const [selectedMayorQue, setSelectedMayorQue] = useState(0);
      const [selectedMenorQue, setSelectedMenorQue] = useState(0);
  const [selectedClienteFiltro, setSelectedClienteFiltro] = useState("");
  const [selectedConceptoFiltro, setSelectedConceptoFiltro] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [idEdit, setIdEdit] = useState();
  const [fecha, setFecha] = useState(hoy);
  const [totalUSD, setTotalUSD] = useState(0);
  const [tipoCambio, setTipoCambio] = useState(1);
  const [total, setTotal] = useState(0);
  const [descripcion, setDescripcion] = useState("NA");
  const [conceptosGastos, setConceptosGastos] = useState([]);
  const [selectedConcepto, setSelectedConcepto] = useState("");
  const [contenedores, setContenedores] = useState([]);
  const [selectedContenedor, setSelectedContenedor] = useState("");
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [moneda, setMoneda] = useState("");

    const [modalArchivo, setModalArchivo] = useState(false);
    const toggleArchivo = () => setModalArchivo(!modalArchivo);

  const [validaBoton, setValidaBoton] = useState(true);
      const [inputFields, setInputFields] = useState([
        {
          id: uuidv4(),
          fecha: "",
          totalUSD: "",
          tipoCambio: "",
          total: "",
          abonos: "",
          saldo: "",
          descripcion: "",
          conceptosGastos: "",
          conceptoNombre: "",
          contenedores: "",
          contenedoresNombre: "",
          clientes: "",
          clienteNombre: "",
          moneda: "",
        },
      ]);

        const [modalProgreso, setModalProgreso] = useState(false);
        const toggleProgreso = () => setModalProgreso(!modalProgreso);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  // IDs desmarcados para el PDF. Vacío = todos incluidos (default).
  const [excludedPdfIds, setExcludedPdfIds] = useState([]);
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(
        `${URL_CARGOS_CONTENEDOR}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((response) => {
        let allCargos = response.data;
        let arrayTabla = allCargos
          .sort((a, b) => (a.fecha < b.fecha ? 1 : -1))
          .map((a) => {
            const fechaCargo = new Date(a.fecha);
            // const fechaActual = new Date();
            const fechaActual = new Date();
  
            // Fecha límite de edición (15 del mes anterior o 15 del mes actual)
            let mesEdicion = fechaActual.getDate() < 15
              ? fechaActual.getMonth() - 1
              : fechaActual.getMonth();
            let year = fechaActual.getFullYear();
    
            if (mesEdicion < 0) {
              mesEdicion = 11; // Diciembre
              year -= 1; // Año anterior
            }
    
           // Convertir mes y día a formato de dos dígitos
          const mesEdicionFormatted = (mesEdicion + 1).toString().padStart(2, '0'); // `+1` porque los meses en JavaScript son 0-11
          const diaEdicionFormatted = '15';
  
          // Formatear la fecha límite de edición a AAAA-MM-DD
          const fechaLimiteEdicion = `${year}-${mesEdicionFormatted}-${diaEdicionFormatted}`;
  
          // Convertir la fecha del Cargo a formato AAAA-MM-DD para la comparación
          const fechaCargoFormatted = fechaCargo.toISOString().split('T')[0];
  
          // Determinar si se puede editar
          const poderEditar = fechaCargoFormatted > fechaLimiteEdicion ? "Si" : "No";

            return {
              _id: a._id,
              numero: a.idCargoContenedor,
              fecha: a.fecha,
              descripcion: a.descripcion,
              totalUSD: a.totalUSD,
              tipoCambio: a.tipoCambio,
              total: a.total,
              abonos: a.abonos,
              concepto: a.conceptosGastos[0].name,
              cliente: a.clientes[0].nombre_comercial,
              idCliente: a.clientes[0]._id,
              contenedor: a.contenedores[0].contenedor,
              numeroBl: a.contenedores[0].numeroBl,
              idContenedor: a.contenedores[0]._id,
              idConceptosGastos: a.conceptosGastos[0]._id,
              moneda: a.moneda,
              saldo: a.saldo,
              poderEditar: poderEditar,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_CONCEPTOS_GASTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allConceptosGastos = res.data;
        setConceptosGastos(allConceptosGastos);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_CONTENEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allContenedores = res.data;
        setContenedores(allContenedores);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [user, selectedFechaInicio, selectedFechaFin]);

  let totalTabla = 0;

  // Búsqueda que acepta VARIOS términos separados por coma (OR).
  // Ej: "ONEU4299998, TCLU1234567" trae los cargos de ambos contenedores.
  // Un solo término (sin coma) se comporta igual que antes (frase completa).
  const matchesSearch = (comment, search) => {
    if (!search) return true;
    const terms = String(search)
      .split(",")
      .map((t) => t.trim())
      .filter((t) => t.length > 0);
    if (terms.length === 0) return true;

    const matchesTerm = (raw) => {
      const s = raw.toLowerCase();
      return (
        (comment.concepto || "").toLowerCase().includes(s) ||
        (comment.contenedor || "").toLowerCase().includes(s) ||
        (comment.cliente || "").toLowerCase().includes(s) ||
        (comment.descripcion || "").toLowerCase().includes(s) ||
        String(comment.numero ?? "").includes(raw) ||
        String(comment.total ?? "").includes(raw) ||
        String(comment.abonos ?? "").includes(raw) ||
        String(comment.saldo ?? "").includes(raw)
      );
    };

    return terms.some(matchesTerm);
  };

  function PDFTabla() {
    let total = 0;
    const data = comments.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) &&
        (selectedMayorQue == 0 || selectedMayorQue <= c.numero) &&
        (selectedMenorQue == 0 || selectedMenorQue >= c.numero) &&
        (selectedClienteFiltro == "" || c.idCliente == selectedClienteFiltro) &&
        (selectedConceptoFiltro == "" || c.idConceptosGastos == selectedConceptoFiltro) &&
        matchesSearch(c, search) &&
        // ✅ excluir los cargos desmarcados en la columna PDF
        !excludedPdfIds.includes(String(c._id))
      ) {
        total = total + c.total;
        const importePDF = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
          roundingIncrement: 5,
        }).format(c.total);
        return [c.fecha, c.concepto, c.descripcion, importePDF];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
    doc.text("Detalle de Cargos", 20, 25);
    doc.autoTable({
      head: [["Fecha", "Concepto", "Descripcion", "Importe"]],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
            roundingIncrement: 5,
          }).format(total),
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save("DetalleCargos.pdf");
  }

  function excel() {
    const dataExcel = comments.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) &&
        (selectedMayorQue == 0 || selectedMayorQue <= c.numero) &&
        (selectedMenorQue == 0 || selectedMenorQue >= c.numero) &&
        (selectedClienteFiltro == "" || c.idCliente == selectedClienteFiltro)&&
        (selectedConceptoFiltro == "" || c.idConceptosGastos == selectedConceptoFiltro) &&
        matchesSearch(c, search) &&
        // ✅ excluir los cargos desmarcados en la columna PDF
        !excludedPdfIds.includes(String(c._id))
      ) {
        return {
          Fecha: c.fecha,
          Contenedor: c.contenedor,
          Bl: c.numeroBl,
          Concepto: c.concepto,
          Descripcion: c.descripcion,
          Importe: c.total,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = `DetalleCargos-${selectedFechaInicio}-${selectedFechaFin}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: `DetalleCargos`,
        sheetFilter: ["Fecha", "Contenedor", "Bl", "Concepto", "Descripcion", "Importe"],
        sheetHeader: ["Fecha", "Contenedor", "Bl", "Concepto", "Descripcion", "Importe"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let total = 0;
    const data = comments.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedMayorQue == 0 || selectedMayorQue <= c.numero) &&
        (selectedMenorQue == 0 || selectedMenorQue >= c.numero) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha)
      ) {
        total = total + c.total;
        const importePDF = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
          roundingIncrement: 5,
        }).format(c.total);
        return [c.fecha, c.concepto, c.descripcion, importePDF];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
    doc.text("Detalle de Cargos", 20, 25);
    doc.autoTable({
      head: [["Fecha", "Concepto", "Descripcion", "Importe"]],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
            roundingIncrement: 5,
          }).format(total),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Lista de Cargos",
          email: mailTo,
          fileName: "ListaCargos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras la lista de Cargos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const editCargo = (event) => {
   event.preventDefault();

    axios
      .patch(
        `${URL_CARGOS_CONTENEDOR}EditImporte/${idEdit}`,
        {
          fecha,
          totalUSD,
          tipoCambio,
          total,
          abonos: 0,
          saldo: total,
          descripcion,
          conceptosGastos: selectedConcepto,
          moneda,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Edit Cargo",
            detalle: `Fecha: ${fecha} / Descripcion: ${descripcion} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  const headers = [
    { name: `${t("Numero")}`, field: "numero", sortable: true },
    { name: `${t("Fecha")}`, field: "fecha", sortable: true },
    { name: `${t("Concepto")}`, field: "concepto", sortable: true },
    { name: `${t("Descripcion")}`, field: "descripcion", sortable: true },
    { name: `${t("Contenedor")}`, field: "contenedor", sortable: true },
    { name: `${t("Cliente")}`, field: "cliente", sortable: true },
    { name: `${t("Importe")}`, field: "total", sortable: true },
    { name: `${t("Abonos")}`, field: "abonos", sortable: true },
    { name: `${t("Saldo")}`, field: "saldo", sortable: true },
    { name: `${t("Editar")}`, field: "editar", sortable: false },
    { name: "PDF", field: "pdf", sortable: false }, // ✅ incluir en PDFTabla
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter((comment) =>
        matchesSearch(comment, search)
      );
    }

    if (selectedClienteFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idCliente.includes(selectedClienteFiltro)
      );
    }

    if (selectedConceptoFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idConceptosGastos.includes(selectedConceptoFiltro)
      );
    }
    if (selectedMayorQue) {
      computedComments = computedComments.filter(
        (e) => e.numeroContenedor >= selectedMayorQue
      );
    }

    if (selectedMenorQue) {
      computedComments = computedComments.filter(
        (e) => e.numeroContenedor <= selectedMenorQue
      );
    }

    setTotalItems(computedComments.length);

 //Sorting comments
 if (
  sorting.field &&
  sorting.field != "total" &&
  sorting.field != "saldo" &&
  sorting.field != "abonos"
) {
  const reversed = sorting.order === "asc" ? 1 : -1;
  computedComments = computedComments.sort(
    (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
  );
}

if (
  sorting.field &&
  sorting.order === "asc" &&
  (sorting.field == "total" ||
    sorting.field == "saldo" ||
    sorting.field == "abonos")
) {
  computedComments = computedComments.sort((a, b) =>
    parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
  );
}

if (
  sorting.field &&
  sorting.order === "desc" &&
  (sorting.field == "total" ||
    sorting.field == "saldo" ||
    sorting.field == "abonos")
) {
  computedComments = computedComments.sort((a, b) =>
    parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
  );
}

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedClienteFiltro,
    selectedConceptoFiltro,
    selectedFechaInicio,
    selectedFechaFin,
    selectedMayorQue,
    selectedMenorQue,
  ]);



  const calcula = (e) => {
    setTotalUSD(e);
    setTotal(parseFloat(e) * parseFloat(tipoCambio));
  };

  const calculaTipoCambio = (e) => {
    setTipoCambio(e);
    setTotal(parseFloat(totalUSD) * parseFloat(e));
  };

  function jalaContenedor(e) {
    setSelectedContenedor(e);

    contenedores.map((a) => {
      if (a._id == e) {
        setSelectedCliente(a.clientes[0]._id);
      }
    })
  }

//   function importarArchivo(event) {
//   const target = event.target;
//   if (!target?.files?.[0]) return;

//   let hojas = [];

//   const reader = new FileReader();
//   reader.readAsArrayBuffer(target.files[0]);
//   reader.onloadend = (e) => {
//     const data = new Uint8Array(e.target.result);
//     const workbook = XLSX.read(data, { type: "array" });

//     // Siempre la primera hoja
//     const firstSheet = workbook.SheetNames[0];
//     const XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet]);
//     hojas.push({ data: XL_row_object, sheetName: firstSheet });

//     const A1 = hojas[0].data;

//     // Mapa de contenedores activos
//     const contenedoresMap = {};
//     contenedores
//       .filter((cont) => cont.is_active === "Si")
//       .forEach((cont) => {
//         contenedoresMap[cont.referencia?.trim()] = cont;
//       });

//     // Mapa de conceptos
//     const conceptosGastosMap = {};
//     conceptosGastos.forEach((concepto) => {
//       const key = concepto.name?.trim().toLowerCase();
//       if (key) {
//         conceptosGastosMap[key] = concepto._id;
//       }
//     });

//     const contenedoresNoEncontrados = new Set();
//     const conceptosNoEncontrados = new Set();

//     // Función para formatear fecha
//     const formatFecha = (value) => {
//       if (!value) return "";
//       let d;
//       if (value instanceof Date) {
//         d = value;
//       } else if (!isNaN(value)) {
//         // Número Excel
//         d = XLSX.SSF.parse_date_code(value);
//         return `${d.y}-${String(d.m).padStart(2, "0")}-${String(d.d).padStart(2, "0")}`;
//       } else {
//         // Texto
//         const parts = value.toString().split(/[-/]/);
//         if (parts.length === 3) {
//           const [y, m, day] = parts[0].length === 4 ? parts : [parts[2], parts[1], parts[0]];
//           return `${y}-${String(m).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
//         }
//         return value;
//       }
//       return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
//     };

//     // Recorrer Excel
//     for (const a of A1) {
//       const referencia = a.Referencia?.trim();
//       const conceptoKey = a.Concepto?.trim().toLowerCase();
//       const fechaFormat = formatFecha(a.Fecha);
//       const cargo = Number(a.Cargo) || 0;

//       const cont = contenedoresMap[referencia];
//       const conceptoId = conceptosGastosMap[conceptoKey];

//       if (cont) {
//         if (conceptoId) {
//           inputFields.push({
//             id: uuidv4(),
//             fecha: fechaFormat,
//             totalUSD: cargo,
//             tipoCambio: 1,
//             total: cargo,
//             abonos: 0,
//             saldo: cargo,
//             descripcion: "NA",
//             conceptosGastos: conceptoId,
//             conceptoNombre: a.Concepto,
//             contenedores: cont._id,
//             contenedoresNombre: cont.referencia,
//             clientes: cont.clientes[0]._id,
//             clienteNombre: cont.clientes[0].nombre_comercial,
//             moneda: "MXN",
//           });
//         } else {
//           conceptosNoEncontrados.add(a.Concepto?.trim());
//         }
//       } else {
//         contenedoresNoEncontrados.add(a.Referencia?.trim());
//       }
//     }

//     // Alerta si hay faltantes
//     if (contenedoresNoEncontrados.size > 0 || conceptosNoEncontrados.size > 0) {
//       Swal.fire({
//         title: "Elementos no encontrados",
//         html: `
//           ${contenedoresNoEncontrados.size > 0 ? `<b>Contenedores:</b> ${[...contenedoresNoEncontrados].join(", ")}<br>` : ""}
//           ${conceptosNoEncontrados.size > 0 ? `<b>Conceptos:</b> ${[...conceptosNoEncontrados].join(", ")}` : ""}
//         `,
//         icon: "warning",
//         confirmButtonText: "Entendido",
//       });
//     }

//     // Actualizar totales si aplica
//     // ActualizaTotales();
//   };
// }

function importarArchivo(event) {
  const target = event.target;
  if (!target?.files?.[0]) return;

  let hojas = [];

  const reader = new FileReader();
  reader.readAsArrayBuffer(target.files[0]);
  reader.onloadend = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: "array" });

    // Siempre la primera hoja
    const firstSheet = workbook.SheetNames[0];
    const XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet]);
    hojas.push({ data: XL_row_object, sheetName: firstSheet });

    const A1 = hojas[0].data;

    // Mapa de contenedores activos
    const contenedoresMap = {};
    contenedores
      .filter((cont) => cont.is_active === "Si")
      .forEach((cont) => {
        contenedoresMap[cont.referencia?.trim()] = cont;
      });

    // Mapa de conceptos
    const conceptosGastosMap = {};
    conceptosGastos.forEach((concepto) => {
      const key = concepto.name?.trim().toLowerCase();
      if (key) {
        conceptosGastosMap[key] = concepto._id;
      }
    });

    const contenedoresNoEncontrados = new Set();
    const conceptosNoEncontrados = new Set();
    const nuevosRegistros = [];

    // Función para formatear fecha
    const formatFecha = (value) => {
      if (!value) return "";
      let d;
      if (value instanceof Date) {
        d = value;
      } else if (!isNaN(value)) {
        // Número Excel
        d = XLSX.SSF.parse_date_code(value);
        return `${d.y}-${String(d.m).padStart(2, "0")}-${String(d.d).padStart(2, "0")}`;
      } else {
        // Texto
        const parts = value.toString().split(/[-/]/);
        if (parts.length === 3) {
          const [y, m, day] = parts[0].length === 4 ? parts : [parts[2], parts[1], parts[0]];
          return `${y}-${String(m).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
        }
        return value;
      }
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    };

    // Recorrer Excel
    for (const a of A1) {
      const referencia = a.Referencia?.trim();
      const conceptoKey = a.Concepto?.trim().toLowerCase();
      const fechaFormat = formatFecha(a.Fecha);
      const cargo = Number(a.Cargo) || 0;

      const cont = contenedoresMap[referencia];
      const conceptoId = conceptosGastosMap[conceptoKey];

      if (cont && conceptoId) {
        nuevosRegistros.push({
          id: uuidv4(),
          fecha: fechaFormat,
          totalUSD: cargo,
          tipoCambio: 1,
          total: cargo,
          abonos: 0,
          saldo: cargo,
          descripcion: "NA",
          conceptosGastos: conceptoId,
          conceptoNombre: a.Concepto,
          contenedores: cont._id,
          contenedoresNombre: cont.referencia,
          clientes: cont.clientes[0]._id,
          clienteNombre: cont.clientes[0].nombre_comercial,
          moneda: "MXN",
        });
      } else {
        if (!cont) contenedoresNoEncontrados.add(a.Referencia?.trim());
        if (!conceptoId) conceptosNoEncontrados.add(a.Concepto?.trim());
      }
    }

    // 🔹 ACTUALIZAR ESTADO para que React re-renderice el modal
    setInputFields((prev) => [...prev, ...nuevosRegistros]);

    // Alerta si hay faltantes
    if (contenedoresNoEncontrados.size > 0 || conceptosNoEncontrados.size > 0) {
      Swal.fire({
        title: "Elementos no encontrados",
        html: `
          ${contenedoresNoEncontrados.size > 0 ? `<b>Contenedores:</b> ${[...contenedoresNoEncontrados].join(", ")}<br>` : ""}
          ${conceptosNoEncontrados.size > 0 ? `<b>Conceptos:</b> ${[...conceptosNoEncontrados].join(", ")}` : ""}
        `,
        icon: "warning",
        confirmButtonText: "Entendido",
      });
    }
  };
}

  console.log("hola", inputFields)

    const saveCargos = async () => {

    setValidaBoton(false);
    toggleProgreso();
    let totalPedido = inputFields.length - 1;
    
    try {
        await Promise.all(inputFields
          .filter((e) => e.total > 0)
          .map(a =>
            axios.post(
                `${URL_CARGOS_CONTENEDOR}`,
                {
                   fecha: a.fecha,
                  totalUSD: a.totalUSD,
                  tipoCambio: 1,
                  total: a.total,
                  abonos: 0,
                  saldo: a.total,
                  descripcion: "NA",
                  conceptosGastos: a.conceptosGastos,
                  contenedores: a.contenedores,
                  clientes: a.clientes,
                  moneda: "MXN",
                },
                {
                    headers: {
                        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                }
            )
        ));

        await axios.post(
            URL_LOGS,
            {
                tipo: "Subir Cargos Contenedores",
                detalle: `Varios cargos contenedores`,
                user: user.id,
            },
            {
                headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
            }
        );

        Swal.fire("Good job!", "Creado con éxito", "success");
        setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
        });
        console.log(error);
        setValidaBoton(true);
    }
};

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menuCargos ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card style={{ width: 'auto' }}">
              <div className="card-body">
                <Row>
                  <Col md={7}>
                    <Button
                      size="sm"
                      href="/MenuAdmin"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      {t("Regresar")}
                    </Button>
                  </Col>
                  <Col md={5}>
                    <ButtonGroup id="logoutBoton">
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={toggleArchivo}
                      >
                        Archivo <i class="fas fa-upload"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={PDFTabla}
                      >
                        PDF <i class="far fa-file-pdf"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={toggleMail}
                      >
                        eMail <i class="fas fa-at"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="primary"
                        onClick={excel}
                      >
                        Excel <i class="far fa-file-excel"></i>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
                <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                  <ModalHeader toggle={toggleMail}>
                    <h4>{t(<Header />)}</h4>
                  </ModalHeader>
                  <ModalBody>
                    <Label className="mr-sm-2">Email</Label>
                    <Input
                      className="col-sm-12"
                      type="text"
                      value={mailTo}
                      required
                      onChange={(e) => {
                        setMailTo(e.target.value);
                      }}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button size="sm" color="success" onClick={enviaMail}>
                      {t("Enviar")}
                    </Button>
                  </ModalFooter>
                </Modal>
                <br />
                <h3 align="center">{t("Cargos Contenedores")}</h3>
                <Row>
                  <Col md={2}>
                    <Label>{t("Fecha Inicio")}</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaInicio}
                      onChange={(e) => {
                        setSelectedFechaInicio(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>{t("Fecha Fin")}</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaFin}
                      onChange={(e) => {
                        setSelectedFechaFin(e.target.value);
                      }}
                    />
                  </Col>

                  <Col md={2}>
                    <Label className="mr-sm-2">{t("Mayor Que")}</Label>
                    <Input
                      bsSize="sm"
                      type="number"
                      value={selectedMayorQue}
                      required
                      onChange={(e) => {
                        setSelectedMayorQue(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label className="mr-sm-2">{t("Menor Que")}</Label>
                    <Input
                      bsSize="sm"
                      type="number"
                      value={selectedMenorQue}
                      required
                      onChange={(e) => {
                        setSelectedMenorQue(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>{t("Cliente")}</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedClienteFiltro}
                      onChange={(e) => {
                        setSelectedClienteFiltro(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">{t("Selecciona")}</option>
                      {clientes
                        .sort((a, b) =>
                          a.nombre_comercial > b.nombre_comercial ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre_comercial}</option>
                          );
                        })}
                    </Input>
                  </Col>

                  <Col md={2}>
                    <Label>{t("Concepto")}</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedConceptoFiltro}
                      onChange={(e) => {
                        setSelectedConceptoFiltro(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">{t("Selecciona")}</option>
                      {conceptosGastos
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                </Row>
                <br />
                <div className="row">
                  <div className="col-md-6">
                    <Pagination
                      total={totalItems}
                      itemsPerPage={ITEMS_PER_PAGE}
                      currentPage={currentPage}
                      onPageChange={(page) => setCurrentPage(page)}
                    />
                  </div>
                  <div className="col-md-6 d-flex flex-row-reverse">
                    <Search
                      placeholder="Buscar... (varios contenedores separados por coma)"
                      onSearch={(value) => {
                        setSearch(value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
                <Table
                  size="sm"
                  striped
                  borderless
                  className="table-responsive-xl"
                >
                  <TableHeader
                    headers={headers}
                    onSorting={(field, order) => setSorting({ field, order })}
                  />

                  <tbody>
                    {commentsData.map((c) => {
                      totalTabla = totalTabla + c.total;
                      return (
                        <tr>
                          <td>{c.numero}</td>
                          <td>{c.fecha}</td>
                          <td>{c.concepto}</td>
                          <td>{c.descripcion}</td>
                          <td>{c.contenedor}</td>
                          <td>{c.cliente}</td>
                          <td>
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                              roundingIncrement: 5,
                            }).format(c.total)}
                          </td>{" "}
                          <td>
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                              roundingIncrement: 5,
                            }).format(c.abonos)}
                          </td>{" "}
                          <td>
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                              roundingIncrement: 5,
                            }).format(c.saldo)}
                          </td>
                          <td>
                            {c.saldo == c.total ? (
                              // && c.poderEditar == "Si"
                              <Button
                                color="info"
                                id="Editar"
                                size="sm"
                                onClick={(e) => {
                                  setIdEdit(c._id);
                                  setFecha(c.fecha);
                                  setTotalUSD(c.totalUSD);
                                  setTipoCambio(c.tipoCambio);
                                  setTotal(c.total);
                                  setDescripcion(c.descripcion);
                                  setSelectedConcepto(c.idConceptosGastos);
                                  setSelectedContenedor(c.idContenedor);
                                  setSelectedCliente(c.idCliente);
                                  setMoneda(c.moneda);
                                  toggleEdit();
                                }}
                              >
                                <i class="fas fa-edit"></i>
                              </Button>
                            ) : undefined}
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              checked={!excludedPdfIds.includes(String(c._id))}
                              onChange={(e) => {
                                const id = String(c._id);
                                const incluir = e.target.checked;
                                setExcludedPdfIds((prev) =>
                                  incluir
                                    ? prev.filter((x) => x !== id)
                                    : Array.from(new Set([...prev, id]))
                                );
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        TOTAL
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                          roundingIncrement: 5,
                        }).format(totalTabla)}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </Table>
                <div className="col-md-6">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
              </div>
            </div>
          </div>

          <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
            <ModalHeader toggle={toggleEdit}>
              <h4> {t("Editar Cargo")}</h4>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">{t("Fecha")}</Label>
                  <Input
                    type="date"
                    placeholder="Fecha"
                    value={fecha}
                    required
                    onChange={(e) => {
                      setFecha(e.target.value);
                    }}
                  />
                </Col>
                <Col md={6}>
                  <Label className="mr-sm-2">{t("Contenedor")}</Label>
                  <Input
                    // bsSize="sm"
                    type="select"
                    required
                    value={selectedContenedor}
                    disabled
                  >
                    <option value="0">{t("Selecciona")}</option>
                    {contenedores
                      .sort((a, b) =>
                        a.numeroInterno > b.numeroInterno ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.numeroInterno}</option>;
                      })}
                  </Input>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">{t("Cliente")}</Label>
                  <Input
                    // bsSize="sm"
                    type="select"
                    required
                    value={selectedCliente}
                    disabled
                  >
                    <option value="0">{t("Selecciona")}</option>
                    {clientes
                      .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1
                      )
                      .map((a) => {
                        return (
                          <option value={a._id}>{a.nombre_comercial}</option>
                        );
                      })}
                  </Input>
                </Col>
                <Col md={6}>
                  <Label className="mr-sm-2">{t("Concepto")}</Label>
                  <Input
                    // bsSize="sm"
                    type="select"
                    required
                    value={selectedConcepto}
                    onChange={(e) => setSelectedConcepto(e.target.value)}
                  >
                    <option value="0">{t("Selecciona")}</option>
                    {conceptosGastos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    {t("Descripcion")}
                  </Label>
                  <Input
                    type="text"
                    placeholder="Descripcion"
                    value={descripcion}
                    required
                    onChange={(e) => {
                      setDescripcion(e.target.value);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">{t("Moneda")}</Label>
                  <Input
                    // bsSize="sm"
                    type="select"
                    required
                    value={moneda}
                    onChange={(e) => {
                      setMoneda(e.target.value);
                      setTotalUSD(0);
                      setTotal(0);
                      setTipoCambio(1);
                    }}
                  >
                    <option value="MXN">{t("MXN")}</option>
                    <option value="USD">{t("USD")}</option>
                  </Input>
                </Col>
              </Row>
              {moneda === "USD" ? (
                <Row>
                  <Col sm={4}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      {t("Total USD")}
                    </Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="TotalUSD"
                      value={totalUSD}
                      required
                      onChange={(e) => calcula(e.target.value)}
                    />
                  </Col>
                  <Col sm={4}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Tipo de Cambio
                    </Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="TipoCambio"
                      value={tipoCambio}
                      required
                      onChange={(e) => calculaTipoCambio(e.target.value)}
                    />
                  </Col>
                  <Col sm={4}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      {t("Total MXN")}
                    </Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={total}
                      disabled
                      // onChange={(e) => calculaMXN(e.target.value)}
                    />
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col sm={4}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      {t("Total MXN")}
                    </Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={total}
                      onChange={(e) => {
                        setTotal(e.target.value);
                        setTotalUSD(e.target.value / tipoCambio);
                      }}
                    />
                  </Col>
                </Row>
              )}
            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={editCargo}>
                {t("Guardar")}
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      ) : undefined}

               <Modal size="xl" isOpen={modalArchivo} toggle={toggleArchivo}>
                  <ModalHeader toggle={toggleArchivo}>
                    <h4>{t("Subir Archivo")}</h4>
                  </ModalHeader>
                  <ModalBody>
                    <Row>
                      <Col md={9}>
                        <Input
                          required
                          type="file"
                          name="file"
                          id="file"
                          onChange={(event) => importarArchivo(event)}
                        />
                      </Col>
                    </Row>
                    <br />
      
                    <Table bordered striped>
                      <thead>
                        <tr>
                          <th>Referencia</th>
                          <th>Fecha</th>
                          <th>Cliente</th>
                          <th>Concepto</th>
                          <th>Cargo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {inputFields
                          .filter((a) => a.total > 0)
                          .map((a) => (
                            <tr key={a.id}>
                              <td>{a.contenedoresNombre}</td>
                              <td>{a.fecha}</td>
                              <td>{a.clienteNombre}</td>
                              <td>{a.conceptoNombre}</td>
                              <td>
                                {new Intl.NumberFormat("en-US", {
                                  style: "currency",
                                  currency: "USD",
                                  maximumFractionDigits: 2,
                                }).format(a.total)}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                    <br />
                    {validaBoton ? (
                      <Button color="success" onClick={() => saveCargos()}>
                        Guardar
                      </Button>
                    ) : (
                      <Button color="success" disabled>
                        Guardar
                      </Button>
                    )}
                  </ModalBody>
                </Modal>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>{t("Progreso")}</h4>
            </ModalHeader>
            <ModalBody>
              Estamos enviando los correos, este proceso puede tardar varios
              minutos.
              <br />
              {t("Por favor no cierre ni refresque su navegador.")}
              <br />
              <div className="divPadre2">
                <div className="divHijo2">
                  <Spinner
                    style={{
                      width: "3rem",
                      height: "3rem",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "3rem",
                      height: "3rem",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "3rem",
                      height: "3rem",
                      color: "#232B41",
                    }}
                  />
                </div>
              </div>
            </ModalBody>
          </Modal>
      {loader}
    </>
  );
}

export default ListadoCargosContenedor;
